'use client';

import { footerData } from '@/constant';
import Image from 'next/image';
import enamad from '@/assets/image/enamad.png';
import parkLogo from '@/assets/image/park.jpg';
import new_logo from '@/assets/logo.png';
import Link from 'next/link';
import nezamImage from '@/assets/image/nezam1.png';

import { FaWhatsapp, FaPhoneVolume } from 'react-icons/fa';
import { IoLocationSharp } from 'react-icons/io5';
import { MdContactPhone } from 'react-icons/md';
import { HiOutlineMail } from 'react-icons/hi';
import { FaTelegramPlane } from 'react-icons/fa';
import rubika from '@/assets/rubika.svg';
// import bale from '@/assets/bale-color.svg';
// import instagram from '@/assets/instagram-svgrepo-com.svg';
// import soroush from '@/assets/Soroush-color.svg';
// import eitaa from '@/assets/eitaa-icon-colorful.svg';
export default function Footer() {
    return (
        <footer className="bg-[#ecebf5]">
            <div className="mx-auto max-w-[1280px] py-4 lg:!px-8 px-6 smp:!px-4">
                <div className="sm:gap-6 flex flex-row-reverse items-baseline md:!justify-around justify-between sm:!pl-6 smp:!px-6 md:!px-0 lg:!justify-center pt-2 md:!pt-12 lg:!gap-24 xl:!gap-36">
                    <div className="lg:!gap-36 smp:!gap-24 gap-16 sm:!gap-8 smp:!justify-normal smp:!w-auto smp:pt-0 flex w-full flex-row sm:!justify-evenly justify-center pt-4 md:flex-row">
                        <ul className="[&>*:hover]:-translate-y-0.5 [&>*:hover]:opacity-80 [&>*]:mb-2 [&>*]:block [&>*]:text-[15px] [&>*]:transition-transform">
                            <li className="text-blue md:!text-[15px] !text-sm hover:!translate-0 !mb-4 font-bold hover:!opacity-100">
                                دسترسی سریع
                            </li>
                            {footerData.col_2.map((i) => (
                                <li className="text-sm" key={i.id}>
                                    <Link
                                        prefetch={false}
                                        className="cursor-pointer"
                                        href={i.link}
                                    >
                                        {i.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                        <ul className="[&>*:hover]:-translate-y-0.5 [&>*:hover]:opacity-80 [&>*]:mb-2 [&>*]:block [&>*]:text-[15px] [&>*]:transition-transform">
                            <li className="text-blue md:!text-[15px] !text-sm hover:!translate-0 !mb-4 font-bold hover:!opacity-100">
                                خدمات
                            </li>
                            {footerData.col_3.map((i) => (
                                <li className="text-sm" key={i.id}>
                                    <Link
                                        prefetch={false}
                                        className="text-sm"
                                        href={i.link}
                                    >
                                        {i.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="md:!w-[300px] w-max lg:!w-max">
                        <div className="flex_col md:!flex hidden gap-[4px]">
                            <div className="items-center gap-2 flex">
                                <IoLocationSharp />
                                <p className="text-[15px]">
                                    {footerData.col_1[1]?.address}
                                </p>
                            </div>
                            <Link
                                className="text-sm md:text-base flex gap-1.5 items-center"
                                href={`tel:${footerData.col_1[2]?.phone}`}
                            >
                                <MdContactPhone />
                                {footerData.col_1[2]?.phone}
                            </Link>
                            <Link
                                className="text-sm md:text-base flex gap-1.5 items-center"
                                href={`tel:${footerData.col_1[3].phone2}`}
                            >
                                <FaPhoneVolume />
                                {footerData.col_1[3]?.phone2}
                            </Link>
                            <Link
                                className="flex gap-1.5 items-center"
                                href={`mailto:${footerData.col_1[4].email}`}
                            >
                                <HiOutlineMail className="min-w-4 min-h-4" />
                                {footerData.col_1[4]?.email}
                            </Link>
                        </div>

                        <p className="smp:!block !mb-4 hidden pt-6 md:!text-[15px] text-sm font-bold !text-blue">
                            مجوزها
                        </p>
                        <div className="smp:!grid md:!flex !hidden grid-cols-[1fr,1fr] flex-row items-center gap-4">
                            <div
                                onClick={() =>
                                    window.open(
                                        'https://trustseal.enamad.ir/?id=244259&Code=Nnib8982mgV6zJz9CUz9',
                                        '_blank',
                                        'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600',
                                    )
                                }
                            >
                                <Image
                                    className="size-[70px] mx-auto"
                                    src={enamad}
                                    alt="اینماد"
                                    width={80}
                                    height={80}
                                />
                            </div>
                            <div
                                onClick={() =>
                                    window.open(
                                        'https://fars.irannsr.org/fa/page/104792-%D9%85%D8%B4%D8%A7%D9%87%D8%AF%D9%87-%D8%A7%D8%B9%D8%B6%D8%A7.html?ctp_id=1086&amp;id=25894',
                                        '_blank',
                                        'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600',
                                    )
                                }
                            >
                                <Image
                                    className="h-16 w-auto object-contain"
                                    src={nezamImage.src}
                                    alt="نظام صنفی رایانه ای"
                                    width={80}
                                    height={80}
                                />
                            </div>
                            <div
                                onClick={() =>
                                    window.open(
                                        'https://www.zarinpal.com/trustPage/darmanshirin.com',
                                        '_blank',
                                        'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600',
                                    )
                                }
                                id="zarinpal"
                            >
                                <Image
                                    className="h-16 w-auto object-contain"
                                    width={80}
                                    height={80}
                                    src="https://cdn.zarinpal.com/badges/trustLogo/1.svg"
                                    alt="دروازه پرداخت معتبر"
                                />
                            </div>
                            <div
                                onClick={() =>
                                    window.open(
                                        'https://www.fstp.ir',
                                        '_blank',
                                        'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600',
                                    )
                                }
                                id="park"
                            >
                                <Image
                                    className="h-16 w-auto object-contain"
                                    width={80}
                                    height={80}
                                    src={parkLogo}
                                    alt="پارک علم و فناوری فارس"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="smp:!hidden block sm:px-6 pt-6">
                    <p className="font-bold text-blue pt-3 text-[14px] !mb-4">
                        مجوزها
                    </p>
                    <div className="flex items-center justify-between gap-4">
                        <div
                            onClick={() =>
                                window.open(
                                    'https://trustseal.enamad.ir/?id=244259&Code=Nnib8982mgV6zJz9CUz9',
                                    '_blank',
                                    'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600',
                                )
                            }
                        >
                            <Image
                                className="h-16 w-auto object-contain"
                                referrerPolicy="origin"
                                src={enamad}
                                alt="اینماد"
                                width={80}
                                height={80}
                            />
                        </div>
                        <div
                            onClick={() =>
                                window.open(
                                    'https://fars.irannsr.org/fa/page/104792-%D9%85%D8%B4%D8%A7%D9%87%D8%AF%D9%87-%D8%A7%D8%B9%D8%B6%D8%A7.html?ctp_id=1086&amp;id=25894',
                                    '_blank',
                                    'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600',
                                )
                            }
                        >
                            <Image
                                className="h-16 w-auto object-contain"
                                src={nezamImage.src}
                                alt="نظام صنفی رایانه ای"
                                width={80}
                                height={80}
                            />
                        </div>
                        <div
                            onClick={() =>
                                window.open(
                                    'https://www.zarinpal.com/trustPage/darmanshirin.com',
                                    '_blank',
                                    'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600',
                                )
                            }
                            id="zarinpal"
                        >
                            <Image
                                className="h-16 w-auto object-contain"
                                width={80}
                                height={80}
                                src="https://cdn.zarinpal.com/badges/trustLogo/1.svg"
                                alt="دروازه پرداخت معتبر"
                            />
                        </div>
                        <div
                            onClick={() =>
                                window.open(
                                    'https://www.fstp.ir',
                                    '_blank',
                                    'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600',
                                )
                            }
                            id="park"
                        >
                            <Image
                                className="h-16 w-auto object-contain"
                                width={80}
                                height={80}
                                src={parkLogo}
                                alt="پارک علم و فناوری فارس"
                            />
                        </div>
                    </div>
                </div>

                <div className="pt-10 sm:!pr-6 flex flex-col gap-3 mb-3 pb-4  md:!hidden">
                    <div className="items-center gap-2 flex">
                        <IoLocationSharp />
                        <p className="text-[15px]">
                            {footerData.col_1[1]?.address}
                        </p>
                    </div>
                    <Link
                        className="text-sm md:text-base flex gap-1.5 items-center"
                        href={`tel:${footerData.col_1[2]?.phone}`}
                    >
                        <MdContactPhone />
                        {footerData.col_1[2]?.phone}
                    </Link>
                    <Link
                        className="text-sm md:text-base flex gap-1.5 items-center"
                        href={`tel:${footerData.col_1[3].phone2}`}
                    >
                        <FaPhoneVolume />
                        {footerData.col_1[3]?.phone2}
                    </Link>
                    <Link
                        className="flex gap-1.5 items-center"
                        href={`mailto:${footerData.col_1[4].email}`}
                    >
                        <HiOutlineMail className="min-w-4 min-h-4" />
                        {footerData.col_1[4]?.email}
                    </Link>
                </div>

                <hr className="border-[#dedee9] border-2 mt-10 mb-4" />
                <div className="flex justify-center sm:!justify-between items-center sm:!flex-row flex-col flex-wrap gap-4 sm:!gap-2 py-4">
                    <Link href={'/'}>
                        <Image
                            alt="درمان شیرین"
                            width={190}
                            height={230}
                            src={new_logo}
                            unoptimized
                            loading="eager"
                            className="sm:!w-[190px] w-[230px]"
                        />
                    </Link>
                    <span
                        dir="ltr"
                        className="lg:!block hidden text-center text-[15px] text-[#1E2833]"
                    >
                        © تمامی حقوق برای وب سایت درمان شیرین محفوظ است - 1404
                    </span>
                    <div className="flex flex-row-reverse justify-center gap-2 md:!gap-4 !text-xl">
                        <a
                            href="https://wa.me/09338505757"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="border border-main text-blue rounded-full p-2 bg-transparent"
                            title="واتساپ درمان شیرین"
                        >
                            <FaWhatsapp
                                name="whatsapp-icon"
                                className="text-[#207f42]"
                            />
                        </a>
                        <a
                            href="https://t.me/DarmanShirin"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="border border-main text-blue rounded-full p-2 bg-transparent"
                            title="تلگرام درمان شیرین"
                        >
                            <FaTelegramPlane name="telegram-icon" />
                        </a>
                        {/* <Link
                            href={''}
                            className="border border-main text-blue rounded-full p-2 bg-transparent"
                            prefetch={false}
                            title="اینستاگرام درمان شیرین"
                        >
                            <Image
                                src={instagram}
                                width={1000}
                                height={1000}
                                alt="اینستاگرام درمان شیرین"
                                className="size-[20px]"
                            />
                        </Link> */}
                        <a
                            href={'https://rubika.ir/Darmanshirin'}
                            className="border border-main text-blue rounded-full p-2 bg-transparent"
                            target="_blank"
                            rel="noopener noreferrer"
                            title="روبیکا درمان شیرین"
                        >
                            <Image
                                src={rubika}
                                width={80}
                                height={80}
                                alt="روبیکا درمان شیرین"
                                className="size-[20px]"
                            />
                        </a>
                        {/* <Link
                            href={'https://web.bale.ai/@'}
                            className="border border-main text-blue rounded-full p-2 bg-transparent"
                            prefetch={false}
                            title="بله درمان شیرین"
                        >
                            <Image
                                src={bale}
                                width={1000}
                                height={1000}
                                alt="بله درمان شیرین"
                                className="size-[20px]"
                            />
                        </Link> */}
                    </div>
                </div>
                <span
                    dir="ltr"
                    className="lg:!hidden block text-center text-[15px] text-[#1E2833] pb-4"
                >
                    © تمامی حقوق برای وب سایت درمان شیرین محفوظ است - 1404
                </span>
            </div>
        </footer>
    );
}
